import script from "./TestItemManagement.vue?vue&type=script&setup=true&lang=js"
export * from "./TestItemManagement.vue?vue&type=script&setup=true&lang=js"

import "./TestItemManagement.vue?vue&type=style&index=0&id=338f0125&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-338f0125"]])

export default __exports__